var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "line-height": "28px" } },
    [
      _c("num-input", {
        staticStyle: { width: "100px" },
        attrs: {
          precision: this.precision,
          disabled: Boolean(_vm.checkboxValue.length),
          round: true
        },
        on: { change: _vm.handleInput },
        model: {
          value: _vm.inputValue,
          callback: function($$v) {
            _vm.inputValue = $$v
          },
          expression: "inputValue"
        }
      }),
      _c(
        "el-checkbox-group",
        {
          attrs: { max: 1 },
          on: { change: _vm.handleChange },
          model: {
            value: _vm.checkboxValue,
            callback: function($$v) {
              _vm.checkboxValue = $$v
            },
            expression: "checkboxValue"
          }
        },
        [
          _vm.showTact
            ? _c("el-checkbox", {
                staticStyle: { "padding-left": "2px", width: "30px" },
                attrs: { label: "TACT" }
              })
            : _vm._e(),
          _c("el-checkbox", {
            staticStyle: { "padding-left": "2px", width: "30px" },
            attrs: { label: "NIL" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }